module.exports = __webpack_public_path__ + "img/danantara-logo-black-v3.d4cffbcc.png";